import React, { useContext } from 'react';
import { ThemeContext } from '../theme';

const SCALE = 0.75;
const s = (n) => Math.round(n * SCALE);

export default function NotificationItem({ icon, message }) {
  const theme = useContext(ThemeContext);
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: s(24),
        backgroundColor: theme.cardBg100,
        borderRadius: s(18),
        padding: `${s(18)}px ${s(32)}px`,
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      <div style={{ flexShrink: 0, width: s(24), height: s(24), marginTop: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {icon}
      </div>

      <p
        className="font-satoshi"
        style={{
          flex: 1,
          margin: 0,
          fontSize: s(18),
          lineHeight: `${s(28)}px`,
          fontWeight: 500,
          color: theme.text400,
        }}
      >
        {message}
      </p>
    </div>
  );
}
